import React from 'react';
import { Row, Col, SvgIcon } from 'seduo-ui';
export default class Example extends React.Component {
    render() {
        return (<Row className="icon-list no-gutters">
                <Col xs={1} className="icon-list__icon">
                    <SvgIcon kind="CheckCircle" className="icon-list__svg"/>
                </Col>
                <Col xs={11}>
                    Až 50 videokurzů navíc. Roční cena za licenci je fixní. Každý měsíc však přidáváme několik nových
                    videokurzů, které dostanete zdarma.
                </Col>
            </Row>);
    }
}
